import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { SecurityService } from 'src/app/api/security.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OtpOption } from 'src/app/models/otp-option';

@Component({
    selector: 'auth-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {

  loading = false;
  error: string = null;
  errorNotification: string = null;
  success = false;
  otpOption: OtpOption;

  form = this.fb.group({
    password: [''],
    otpCode: [null, [Validators.minLength(6), this.isOtpRequired().bind(this)]]
  });

  email: string = null;
  token: string = null;
  phoneNumber: string = null;
  otpOptions: OtpOption[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: UntypedFormBuilder,
    private securityService: SecurityService,
  ) {}

  ngOnInit() {
    this.email = this.route.snapshot.queryParamMap.get('email');
    this.token = this.route.snapshot.queryParamMap.get('token');

    // Remove token from URL
    this.router.navigate(['/reset-password']);

    if (!this.email || !this.token) {
      this.error = 'Invalid password reset link';
    } else {
      this.loading = true;
      this.securityService.getPasswordResetOtpOptions(this.email, this.token).subscribe(response => {
        this.loading = false;
        this.otpOptions = response;

        if (this.otpOptions.includes(OtpOption.TOTP)) {
          this.otpOption = OtpOption.TOTP;
        } else if (this.otpOptions.includes(OtpOption.SMS)) {
          this.otpOption = OtpOption.SMS;
          this.sendSms();
        }
      }, err => {
        this.loading = false;
        this.error = err.errors[0].message;
      });
    }
  }

  sendSms() {
    this.otpOption = OtpOption.SMS;
    this.otpCode.reset();

    this.phoneNumber = null;
    this.errorNotification = null;
    this.loading = true;

    this.securityService.sendPasswordResetOtp(this.email, this.token, OtpOption.SMS).subscribe(response => {
      this.loading = false;
      this.phoneNumber = response.maskedPhoneNumber;
    }, err => {
      this.loading = false;
      this.errorNotification = err.errors[0].message;
    });

    return false;
  }

  async resetPassword() {
    this.loading = true;
    this.errorNotification = null;
    this.success = false;

    this.securityService.resetPassword(
      this.email,
      this.token,
      this.password.value,
      this.otpCode.value,
    ).subscribe(response => {
      this.loading = false;
      this.success = response;
    }, err => {
      this.loading = false;
      this.errorNotification = err.errors[0].message;
    });
  }

  isSMS() {
    return this.otpOption === OtpOption.SMS;
  }

  isTOTP() {
    return this.otpOption === OtpOption.TOTP;
  }

  isNone() {
    return !this.otpOption;
  }

  isSmsEnabled() {
    return this.otpOptions && this.otpOptions.includes(OtpOption.SMS);
  }

  isOtpRequired(): ValidatorFn {
    return (control: AbstractControl) => {
      return !this.isNone() && !control.value ? { 'isRequired': true } : null;
    };
  }

  get password() { return this.form.get('password'); }
  get otpCode() { return this.form.get('otpCode'); }
}
